import { render, staticRenderFns } from "./GmbServiceCustomServiceListItem.vue?vue&type=template&id=6080f053&scoped=true&"
import script from "./GmbServiceCustomServiceListItem.vue?vue&type=script&lang=js&"
export * from "./GmbServiceCustomServiceListItem.vue?vue&type=script&lang=js&"
import style0 from "./GmbServiceCustomServiceListItem.vue?vue&type=style&index=0&id=6080f053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080f053",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
